import React, { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';
import { useAuth } from '../../../contexts/AuthContext';
import Icon from '../../../components/AppIcon';

const ProductMetrics = () => {
  const { user } = useAuth();
  const [metrics, setMetrics] = useState({
    totalProducts: 0,
    activeProducts: 0,
    totalViews: 0,
    totalQuoteRequests: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.id) {
      loadMetrics();
    }
  }, [user]);

  const loadMetrics = async () => {
    try {
      setLoading(true);

      const { count: totalCount } = await supabase?.from('provider_products')?.select('*', { count: 'exact', head: true })?.eq('provider_id', user?.id);

      const { count: activeCount } = await supabase?.from('provider_products')?.select('*', { count: 'exact', head: true })?.eq('provider_id', user?.id)?.eq('status', 'active');

      const { data: viewsData } = await supabase?.from('provider_products')?.select('view_count, quote_requests_count')?.eq('provider_id', user?.id);

      const totalViews = viewsData?.reduce((sum, p) => sum + (p?.view_count || 0), 0) || 0;
      const totalQuoteRequests = viewsData?.reduce((sum, p) => sum + (p?.quote_requests_count || 0), 0) || 0;

      setMetrics({
        totalProducts: totalCount || 0,
        activeProducts: activeCount || 0,
        totalViews,
        totalQuoteRequests,
      });
    } catch (error) {
      console.error('Error loading metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  const metricCards = [
    {
      label: 'Totaal Producten',
      value: metrics?.totalProducts,
      icon: 'Package',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      label: 'Actieve Producten',
      value: metrics?.activeProducts,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
    {
      label: 'Totaal Weergaven',
      value: metrics?.totalViews,
      icon: 'Eye',
      color: 'text-info',
      bgColor: 'bg-info/10',
    },
    {
      label: 'Offerteaanvragen',
      value: metrics?.totalQuoteRequests,
      icon: 'FileText',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="h-12 bg-muted rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{metric?.label}</p>
              <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
            </div>
            <div className={`${metric?.bgColor} p-3 rounded-lg`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductMetrics;